import React, { useEffect } from "react";
import { Container } from "reactstrap";
import OnlyHeader from "components/Layout/OnlyHeader.js";
import { useDispatch, useSelector } from "react-redux";
import { getCheckoutQuestion } from "store/actions/checkoutQuestionAction";
import Table from "components/Tables/Table";

const Tables = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getCheckoutQuestion(user?.restaurantID));
  }, [dispatch, user]);

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Table />
      </Container>
    </>
  );
};

export default Tables;
